module.exports = __webpack_public_path__ + "static/media/attach.e019834e.svg";